export default __webpack_public_path__ + "static/media/clock_black.893e09c7.svg";